import React from "react";
import styles from "./Pagination.module.css";

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  pageLimit = 4,
}) => {
  const getVisiblePages = () => {
    const start = Math.floor((currentPage - 1) / pageLimit) * pageLimit + 1;

    const end = Math.min(start + pageLimit - 1, totalPages);

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const pages = getVisiblePages();

  return (
    <div className={styles.pagination}>
      {/* Previous */}
      <button
        className={styles.navBtn}
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        &#8249;
      </button>

      {/* Page Numbers */}
      {pages.map((page) => (
        <button
          key={page}
          className={`${styles.pageBtn} ${
            currentPage === page ? styles.active : ""
          }`}
          onClick={() => onPageChange(page)}
        >
          {page}
        </button>
      ))}

      {/* Next */}
      <button
        className={styles.navBtn}
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        &#8250;
      </button>
    </div>
  );
};

export default Pagination;
